import { render } from "./FormForgotLoginId.vue?vue&type=template&id=4e9fbf36"
import script from "./FormForgotLoginId.vue?vue&type=script&lang=js"
export * from "./FormForgotLoginId.vue?vue&type=script&lang=js"

import "./FormForgotLoginId.vue?vue&type=style&index=0&id=4e9fbf36&lang=scss"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__